
import { mapState, mapGetters } from "vuex";
import MenuUploadBulkUploadScreen from "./menu-upload-bulk-upload-screen.vue";
import MenuUploadEmptyFilteredItemsTile from "./menu-upload-empty-filtered-items-tile.vue";
import MenuUploadGridFilters from "./menu-upload-grid-filters.vue";
import menuUploadGridItem from "./menu-upload-grid-item.vue";
export default {
  components: {
    menuUploadGridItem,
    MenuUploadGridFilters,
    MenuUploadBulkUploadScreen,
    MenuUploadEmptyFilteredItemsTile
  },
  props: {
    attributes: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("menu", ["menuUploadGridFilters"]),
    ...mapGetters("menu", ["getFilteredBulkUploadItems"]),
    filteredAttributes() {
      const filteredItems = this.getFilteredBulkUploadItems(this.id);
      if (!this.menuUploadGridFilters.categorizedView) {
        return [
          {
            id: this.id,
            name: "",
            items: filteredItems
          }
        ];
      } else {
        return filteredItems;
      }
    }
  }
};
